import React, { useState } from "react";
import "./App.css";

import Welcome from "./components/Welcome";
import Survey from "./components/Survey";
import Loading from "./components/Loading";
import Results from "./components/Results";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8080";

function App() {
  const [screen, setScreen] = useState("welcome");
  const [answers, setAnswers] = useState({});
  const [results, setResults] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");

  function start() {
    setErrorMsg("");
    setScreen("survey");
  }

  async function submitSurvey(finalAnswers) {
    setAnswers(finalAnswers);
    setErrorMsg("");
    setScreen("loading");

    try {
      const res = await fetch(API_BASE + "/recommend", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(finalAnswers)
      });

      if (!res.ok) throw new Error("Server error");

      const data = await res.json();

      // ⏱ FORCE 5s LOADING EXPERIENCE
      setTimeout(() => {
        setResults(Array.isArray(data) ? data : []);
        setScreen("results");
      }, 5000);

    } catch (err) {
      setErrorMsg("Unable to load recommendations. Please try again.");
      setScreen("survey");
    }
  }

  function restart() {
    setResults([]);
    setAnswers({});
    setErrorMsg("");
    setScreen("welcome");
  }

  return (
    <div className="app">
      <div className={"screenWrap screen-" + screen}>
        {screen === "welcome" && <Welcome onStart={start} />}
        {screen === "survey" && (
          <Survey
            initialAnswers={answers}
            onSubmit={submitSurvey}
            errorMsg={errorMsg}
          />
        )}
        {screen === "loading" && <Loading />}
        {screen === "results" && (
          <Results results={results} onRestart={restart} />
        )}
      </div>

      <footer className="footer">
        <span>Created by Martin Donev</span>
        <span className="dot">•</span>
        <a
          href="https://github.com/Marty207"
          target="_blank"
          rel="noreferrer"
        >
          GitHub: Marty207
        </a>
      </footer>
    </div>
  );
}

export default App;
